import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Container from "@/components/editorial/Container";
import Eyebrow from "@/components/editorial/Eyebrow";
import SponsorLogo from "@/components/editorial/SponsorLogo";
import { fetchSponsors } from "@/lib/sponsors";

export default function FoundingPartnersHome() {
  const [list, setList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    fetchSponsors({ tier: "founding", status: "active,placeholder" })
      .then((items) => { setList(items.sort((a, b) => (a.order || 0) - (b.order || 0))); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  if (!loaded || list.length === 0) return null;

  return (
    <section data-testid="home-founding-partners" className="bg-cream-dark py-20 md:py-28 border-y border-charcoal/5">
      <Container>
        <div className="text-center max-w-2xl mx-auto mb-12">
          <Eyebrow tone="terracotta" className="mb-4 block">Founding Partners 2026</Eyebrow>
          <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.08]">
            Marcas que creen en las <span className="italic">historias que están cambiando México.</span>
          </h2>
        </div>

        <div className="flex gap-6 md:gap-8 overflow-x-auto snap-x snap-mandatory pb-2 -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap md:justify-center md:overflow-visible">
          {list.map((sp) => (
            <div
              key={sp.id}
              data-testid="founding-partner-card"
              className="snap-start shrink-0 w-[280px] md:w-[320px] bg-cream border border-charcoal/10 p-7 rounded-sm flex flex-col items-center text-center hover:border-terracotta transition-colors"
            >
              <div className="h-20 flex items-center mb-5">
                <SponsorLogo sponsor={sp} tone="light" size="lg" />
              </div>
              <h3 className="font-serif text-xl text-charcoal font-light mb-2">{sp.name}</h3>
              {sp.short_tagline && <p className="text-sm text-charcoal/65 mb-4 leading-relaxed">{sp.short_tagline}</p>}
              {sp.website ? (
                <a href={sp.website} target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-[0.2em] text-terracotta hover:text-[#A64826] inline-flex items-center gap-1.5 mt-auto">
                  Visitar <ArrowRight className="h-3 w-3" />
                </a>
              ) : (
                <Link to="/for-brands#tiers" className="text-xs uppercase tracking-[0.2em] text-terracotta hover:text-[#A64826] inline-flex items-center gap-1.5 mt-auto">
                  Conviértete en Founding <ArrowRight className="h-3 w-3" />
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/for-brands#tiers" data-testid="founding-cta" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-terracotta hover:text-[#A64826]">
            Conviértete en Founding Partner <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Container>
    </section>
  );
}
